export class FornecedoresEstrutura {
  alfix: boolean;
  photoEnergy: boolean;
  fotus: boolean;
  brassunny: boolean;
  romagnole: boolean;
  ssm: boolean;
  lbSolar: boolean;
  viener: boolean;
  ccm: boolean;
  romagnoleOficial: boolean;
  belleSystem: boolean;
  pratyc: boolean;
  e3: boolean;
  solarGroup: boolean;
  vertys: boolean;
  vertys_4: boolean;
  vertys_8: boolean;
  k2: boolean;
}
